import React from "react";
import "./ViewFilter.css";
import { FiUser, FiUsers, FiGlobe } from "react-icons/fi";

const ViewFilter = ({ 
  currentView, 
  onViewChange, 
  userRole, 
  className = "",
  disabled = false 
}) => {
  // Define available views based on user role
  const getAvailableViews = () => {
    const views = [
      {
        id: "myself",
        label: "Myself",
        icon: <FiUser />,
        description: "Only records assigned to me"
      }
    ];

    // Team leads and admins can see team view
    if (userRole === "team lead" || userRole === "admin") {
      views.push({
        id: "team",
        label: "Team",
        icon: <FiUsers />,
        description: "Records for my team members"
      });
    }

    // Only admins can see all view
    if (userRole === "admin") {
      views.push({
        id: "all",
        label: "All",
        icon: <FiGlobe />,
        description: "All records in the system"
      });
    }

    return views;
  };

  const availableViews = getAvailableViews();

  return (
    <div className={`view-filter ${className}`}>
      <div className="view-filter-label">
        View:
      </div>
      <div className="view-filter-buttons">
        {availableViews.map((view) => (
          <button
            key={view.id}
            className={`view-filter-button ${currentView === view.id ? 'active' : ''}`}
            onClick={() => !disabled && onViewChange(view.id)}
            disabled={disabled}
            title={view.description}
          >
            <span className="view-filter-icon">{view.icon}</span>
            <span className="view-filter-text">{view.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ViewFilter;


